import "moment-timezone";
import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { NetworkAxios, UserActivityAxios } from "../../API";
import authSlice from "../../store/auth/authSlice";
//import UserThumbnail from "../userThumbnail/userThumbnail";
import PostComment from "./postComment";
import Checkbox from "../../shared/inputs/Checkbox";

//import { Modal, Button } from "react-bootstrap";
import EditComment from "./EditComment";
import RewardPoints from "./RewardPoints";
import Avatar from "../../shared/commonComponents/Avatar";
import { OverlayTrigger, Popover } from "react-bootstrap";
import ChildComment from "./ChildComment";

const Comment = (props) => {
    const dispatch = useDispatch();
    const offeringUserId = useSelector(
        (state) => state.auth.loggedInUser.offeringUserId
    );
    const loggedInUser = useSelector((state) => state.auth.loggedInUser);
    const currentStage = useSelector((state) => state.appState.currentStage);
    const [showLikesButton, setShowLikesButton] = useState(false);

    const [comment, setComment] = useState(props.comment);
    const [replying, setReplying] = useState(false);
    const [reviewSubmitted, setReviewSubmitted] = useState(false);
    const [coachReviewed, setCoachReviewed] = useState(false);

    // const [editComment, setEditComment] = useState(false);

    // const pointTypes = useSelector((state) => state.auth.pointTypes);

    const allTasks = useSelector((state) => state.auth.missionDetails.tasks);

    const stageActivities = useSelector((state) => state.journeyMapSlice.stageActivities);
    const indivisualAssignment = stageActivities.find(x => x.activityTypeId == 3 && x.isComplete == false);
    const indivisualActivityId = indivisualAssignment ? indivisualAssignment.activityId : 0;
    let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };
    let coachStats = useSelector((state) => state.auth.coachStatsData);

    useEffect(() => {
        setComment(props.comment);
        setCoachReviewed(props.comment && props.comment.coachFeedback ? true : false);

    }, [props.comment]);


    const handleCollapse = (item) => {
        if (item.replies.length > 0) {
            var temp = JSON.parse(JSON.stringify(item));
            temp.collapsed = !temp.collapsed;
            setComment(temp);
        }
    };

    const reloadComments = () => {
        props.reloadComments();
    };
    const handleLikeClick = (comment) => {
        if (comment.offeringUserId == loggedInUser.offeringUserId) {
            return;
        }
        if (comment.isLiked) {
            props.setLikeItem(false, comment);
            if (props.commentFrom == "viewSolution") {
                let requestData = {
                    message: messagePoint,
                    isBackgroundJob: false
                };
                NetworkAxios.put(
                    "SolutionComment/unlikeSolutionComment/" +
                    comment.id +
                    "/" +
                    offeringUserId, requestData
                )
                    .then(function (reponse) {
                        props.reloadComments();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            } else {
                let requestData = {
                    message: messagePoint,
                    isBackgroundJob: false
                };
                NetworkAxios.put(
                    "CommentLike/unlikeComment/" + comment.id + "/" + offeringUserId, requestData
                )
                    .then(function (reponse) {
                        props.reloadComments();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        } else {
            props.setLikeItem(true, comment);
            if (props.commentFrom == "viewSolution") {
                let requestData = {
                    requestModel: {
                        solutionId: props.solutionId,
                        commentId: comment.id,
                        offeringUserId: offeringUserId,
                    },
                    message: messagePoint,
                    isBackgroundJob: false
                };
                NetworkAxios.post("SolutionComment/likesolutionComment", requestData)
                    .then(function (reponse) {
                        props.reloadComments();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            } else {
                let requestData = {
                    requestModel: {
                        id: 0,
                        commentId: comment.id,
                        offeringUserId: offeringUserId,
                    },
                    message: messagePoint,
                    isBackgroundJob: false
                };
                NetworkAxios.post("CommentLike/likeComment", requestData)
                    .then(function (reponse) {
                        if (props.commentFrom !== "viewSolution") {
                            var notificationData = [
                                {
                                    offeringId: loggedInUser.offeringId,
                                    missionId: loggedInUser.missionId,
                                    activityBy: loggedInUser.offeringUserId,
                                    offeringUserId: comment.offeringUserId,
                                    teamId: comment.teamId || 0,
                                    notificationText: `liked your comment on the ${props.thread} thread.`,
                                    actionRoute: JSON.stringify({
                                        action: "like-comment",
                                        url: window.location.pathname,
                                        threadId: props.forumId,
                                        commentId: comment.id,
                                        actionText: "View",
                                        stageId: currentStage,
                                    }),
                                },
                            ];
                            if (comment.offeringUserId !== loggedInUser.offeringUserId) {

                                var requestObject = {
                                    requestModel: notificationData,
                                    message: messagePoint,
                                    isBackgroundJob: false
                                };
                                UserActivityAxios.post(
                                    "Notification/sendnotifications",
                                    requestObject
                                )
                                    .then(function (res) { })
                                    .catch(function (er) {
                                        console.log(er);
                                    });
                            }
                        }

                        props.reloadComments();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }
    };

    const openProfile = (userId, offeringUserId) => {
        dispatch(
            authSlice.actions.setProfileData({
                userId: userId,
                offeringUserId: offeringUserId,
            })
        );
        dispatch(
            authSlice.actions.setProfileStack({
                userId: userId,
                offeringUserId: offeringUserId,
            })
        );
        dispatch(authSlice.actions.setProfileLoader({ showLoader: true }));
        dispatch(authSlice.actions.showProfile());
        setTimeout(function () {
            dispatch(authSlice.actions.setProfileLoader({ showLoader: false }));
        }, 2000);
    };

    const handleCheckBoxClick = (e, item) => {
        var tempPara = "";
        if (e.target.checked) {
            tempPara = "reviewed";
            setCoachReviewed(true);
        }
        else {
            tempPara = "";
            setCoachReviewed(false);
        }

        let requestData = {
            requestModel: { offeringUserActivityId: item.offeringUserActivityId, feedback: tempPara },
            message: messagePoint,
            isBackgroundJob: false
        };

        setReviewSubmitted(true);
        UserActivityAxios.put("OfferingUserActivity/changeassignmentstatusbycoach/", requestData)
            .then(function (reponse) {
                reloadComments();
                dispatch(authSlice.actions.setCoachStats());

                if ((coachStats.totalSubmissions / 2) < coachStats.completedSubmissions) {
                    let tempActivityIdreq = allTasks.find(x => x.activityTypeId == 3 && x.stageId == item.stageId).activityId;
                    var data = [{
                        OfferingUserId: offeringUserId,
                        ActivityId: tempActivityIdreq,
                        IsComplete: true,
                        ActivityCompletedBy: loggedInUser.firstName + " " + loggedInUser.lastName,
                        ActivityCompletedOn: new Date()
                    }];
                    messagePoint.activityId = tempActivityIdreq;
                    var requestObject = {
                        requestModel: data,
                        message: messagePoint,
                        isBackgroundJob: false
                    };
                    UserActivityAxios.put('OfferingUserActivity/updatelearnerdata', requestObject)
                        .then(function (res) {
                            console.log(res);
                        })
                        .catch(function (er) {
                            console.log(er);
                        });
                }
                setReviewSubmitted(false);

            })
            .catch(function (error) {
                console.log(error);
                setReviewSubmitted(false);
            });
    };

    //  const [points, setPoints] = useState(0);
    // const [showReward, setShowReward] = useState(false);

    // const handleShowReward = () => setShowReward(true);
    // const [selectedComment, setSelectedComment] = useState(null);
    // const [showSuccess, setShowSuccess] = useState(false);
    // const [showError, setShowError] = useState(false);

    const popover = (
        <Popover id="popover-basic" className="profilePopover">
            <div className="popover-profile-top-section">
                {/* <div className="profile-picture">
              <div className="profile-avatar">
              <UserThumbnail currentUser={true} className="profile-avatar" />
              </div>
            </div> */}
                <Avatar {...comment.userProfile} className="small" />
                <div className="profile-details">
                    <div className="profile-name">
                        {comment.userProfile.firstName + " " + comment.userProfile.lastName}
                    </div>
                    <div className="profile-teamname">{comment.userProfile.teamName}</div>
                    <div className="profile-missionname">{comment.userProfile.missionName}</div>
                </div>
            </div>
            <div className="popover-profile-bottom-section">
                <div className="profile-email">{comment.userProfile.email}</div>
                <div
                    className="profile-view"
                    onClick={() => {
                        openProfile(comment.userProfile.id, comment.userProfile.offeringUserId);
                    }}
                >
                    View Profile
                </div>
            </div>
        </Popover>
    );

    useEffect(() => {
        if (parseInt(comment.offeringUserId) == parseInt(loggedInUser.offeringUserId)) {
            if (comment.likes > 0) {
                setShowLikesButton(true);
            }
        } else {
            setShowLikesButton(true);
        }
    }, [comment]);

    return (
        <>
            <div className="d-flex" key={comment.id} id={comment.id} style={{ marginBottom: "30px", gap: '10px' }}>
                <div className="alignTextCenterColPad-0">
                    {/* <UserThumbnail data={comment.userProfile}></UserThumbnail> */}
                    <Avatar {...comment.userProfile} className="small" />
                </div>
                <div className="commentWrapper flex-1">
                    <Row className="commnetbackground m-0">
                        <Col style={{ padding: 0 }}>
                            <Row className="commentusernameRow commentorusernameDiv">
                                <Col sm={7} className="commentorusernameDiv">
                                    <OverlayTrigger
                                        trigger="click"
                                        placement="top"
                                        overlay={popover}
                                        rootClose
                                    >
                                        <div className="commentorusername" >
                                            {comment.userProfile.firstName}{" "}
                                            {comment.userProfile.lastName}
                                        </div>
                                    </OverlayTrigger>
                                    <div className="verticalLine"></div>
                                    <Moment parse="YYYY-MM-DD HH:mm" fromNow local={true} className="commentTime ml-auto">
                                        {new Date(comment.commentedOn + "Z")}
                                    </Moment>
                                </Col>
                                <Col sm={2} className="assignmentTagWrapper">
                                    {comment.isAssignment && (
                                        <div className="assignmentTag">Assignment</div>
                                    )}
                                </Col>
                                {showLikesButton &&
                                    < Col
                                        sm={3}
                                        className="commentlikeDiv d-flex justify-content-end"
                                    >
                                        {/* {loggedInUser.userId === comment.userProfile.id &&
                                        <div className='edit-comment' onClick={() => { setEditComment(true) }}>
                                            <div className="icon"></div>
                                            Edit
                                        </div>
                                    } */}
                                        <div
                                            onClick={() => {
                                                handleLikeClick(comment);
                                            }}
                                            className={`thumbsup ${comment.isLiked ? "commentliked" : "commentnotliked"
                                                }`}
                                        ></div>
                                        {comment.likes != 0 && <span>{comment.likes}</span>}
                                    </Col>
                                }
                            </Row>
                            <Row>
                                <Col className="commentdescRow"                                >
                                    <EditComment
                                        comment={comment}
                                        reloadComments={() => props.reloadComments()}
                                        showAssignment={props.showAssignment}
                                        commentFrom={props.commentFrom}
                                        solutionId={props.solutionId}
                                    />

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="replybackground m-0">
                        <Col style={{ padding: 0 }}>
                            <Row>
                                <Col>
                                    <Row className="expandDiv">
                                        <Col>
                                            {!comment.collapsed && comment.replies.length != 0 && (
                                                <>
                                                    <div className="dropupbutton"></div>{" "}
                                                    <span
                                                        onClick={() => {
                                                            handleCollapse(comment);
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        {comment.replies.length} replies from team members
                                                    </span>
                                                </>
                                            )}
                                            {comment.collapsed && (
                                                <span
                                                    onClick={() => {
                                                        handleCollapse(comment);
                                                    }}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    Collapse Chat
                                                </span>
                                            )}
                                        </Col>
                                    </Row>
                                    {comment.collapsed && comment.replies.length > 0 && (
                                        <Row className="expandDiv">
                                            <Col>
                                                {comment.replies
                                                    .sort((a, b) =>
                                                        a.commentedOn < b.commentedOn ? 1 : -1
                                                    )
                                                    .map((commentReply, index) => {
                                                        return (
                                                            <ChildComment {...commentReply} key={`sdnvc${index}`} index={index} parentProps={props} handleLikeClick={handleLikeClick} reloadComments={reloadComments}
                                                                commentFrom={props.commentFrom} />
                                                        );
                                                    })}
                                            </Col>
                                        </Row>
                                    )}
                                    <Row>
                                        <Col className="replyDiv">
                                            <div>
                                                <div className="replycomment"></div>
                                                <span
                                                    onClick={() => {
                                                        setReplying(!replying);
                                                    }}
                                                >
                                                    Reply
                                                </span>
                                            </div>
                                            {loggedInUser.roleId === 5 &&
                                                <div className="coach-actions">
                                                    {comment.isAssignment && (
                                                        !reviewSubmitted ?
                                                            <>
                                                                <Checkbox
                                                                    checked={coachReviewed}
                                                                    onChange={(e) => { handleCheckBoxClick(e, comment); }}
                                                                    label="Mark as reviewed"
                                                                />
                                                            </>
                                                            :
                                                            <>
                                                                <div className="cdx-spinner-btn">
                                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                                                    Review submitting
                                                                </div>
                                                            </>

                                                    )}
                                                    {loggedInUser.offeringUserId !==
                                                        comment.offeringUserId && comment.userProfile.roleId != 5 && (
                                                            <RewardPoints comment={comment} />
                                                        )}
                                                </div>
                                            }
                                        </Col>
                                    </Row>
                                    {replying && props.commentFrom === "viewSolution" && (
                                        <PostComment
                                            thread={props.thread}
                                            showAssignment={false}
                                            comment={comment}
                                            forumId={props.forumId}
                                            commentFrom={props.commentFrom}
                                            reloadComments={() => props.reloadComments()}
                                            solutionId={props.solutionId}
                                            displayAs="Reply"
                                        ></PostComment>
                                    )}
                                    {replying && props.commentFrom !== "viewSolution" && (
                                        <PostComment
                                            thread={props.thread}
                                            showAssignment={false}
                                            commentFrom={props.commentFrom}
                                            reloadComments={() => props.reloadComments()}
                                            forumId={props.forumId}
                                            comment={comment}
                                            displayAs="Reply"
                                        ></PostComment>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div >

        </>
    );
};

export default React.memo(Comment);
